import { Spinner } from '@tempmee/react';
import { Center, Column, Pagination } from '~/commonComponents';
import { CandidateStatus } from '~/domain/PermanentJobs';
import { useEnablePermanentJobMMFeature } from '~/hooks';
import { CandidateStatusFilterPanel } from '../../../components';
import { CandidateListTable, CandidateListTableV2 } from './CandidateListTable';
import { useCandidateTabView } from './useCandidateTabView';

interface ICandidateTabViewProps {
  jobPostingId: string;
  officeId: string;
}

export const CandidateTabView = ({ jobPostingId, officeId }: ICandidateTabViewProps) => {
  const { data, filters, isInitialLoading, isLoading, methods, pagination, statistics } =
    useCandidateTabView(jobPostingId);
  const { isEnablePermanentJobMM } = useEnablePermanentJobMMFeature();

  const hideInviteAndShortlistColumn =
    filters.status === CandidateStatus.Hired || filters.status === CandidateStatus.Rejected;

  return (
    <Column paddingInline={80}>
      <CandidateStatusFilterPanel counts={statistics.tabs} onChange={methods.setStatusFilter} />
      {isInitialLoading ? (
        <Center marginBlock={32}>
          <Spinner centered variant="default" size="md" />
        </Center>
      ) : (
        <>
          {isEnablePermanentJobMM ? (
            <CandidateListTableV2
              data={data}
              hideInviteColumn={hideInviteAndShortlistColumn}
              hideShortlistColumn={hideInviteAndShortlistColumn}
              isLoading={isLoading}
              jobPostingId={jobPostingId}
              officeId={officeId}
              onPageChange={methods.setCurrentPage}
              onSortingChange={methods.setSorting}
              pagination={pagination}
              sorting={filters.sorting}
            />
          ) : (
            <>
              <CandidateListTable
                data={data}
                isLoading={isLoading}
                jobPostingId={jobPostingId}
                sorting={filters.sorting}
                onSortingChange={methods.setSorting}
              />
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={methods.setCurrentPage}
              />
            </>
          )}
        </>
      )}
    </Column>
  );
};
